export function makeId(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function capitalizeString(str) {
  if (!str) {
    return str;
  }

  if (str.length === 1) {
    return str.charAt(0).toUpperCase();
  }

  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const formatFullRestaurantAddress = (restaurant) => {
  const toJoin = [];
  if (restaurant.street) {
    toJoin.push(restaurant.street);
  }

  if (restaurant.city) {
    toJoin.push(restaurant.city);
  }

  if (restaurant.zip) {
    toJoin.push(restaurant.zip);
  }

  if (restaurant.country) {
    toJoin.push(restaurant.country);
  }

  return toJoin.join(', ');
};
